import React from 'react';
import { Check } from 'lucide-react';
import { DUMPSTERS, formatCurrency, type DumpsterSize } from '../../data/dumpsters';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { cn } from '../../lib/utils';
interface SizesSectionProps {
  onReserve: (sizeId: string) => void;
}
export function SizesSection({
  onReserve
}: SizesSectionProps) {
  return <section id="sizes" className="w-full border-t border-border bg-secondary/40 py-16 md:py-24" data-id="element-314">
      <div className="container" data-id="element-315">
        <div className="mx-auto max-w-2xl text-center" data-id="element-316">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-317">
            Choose the right size for your project
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-318">
            Clear rental windows and upfront pricing. Delivery, pickup, and
            disposal up to the listed weight limit are included.
          </p>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-319">
          {DUMPSTERS.map(dumpster => <SizeCard key={dumpster.id} dumpster={dumpster} onReserve={() => onReserve(dumpster.id)} data-id="element-320" />)}
        </div>
        <p className="mt-8 text-center text-sm text-muted-foreground" data-id="element-321">
          Overages may apply by weight. Questions about materials or your
          project? Give us a call before booking.
        </p>
      </div>
    </section>;
}
function SizeCard({
  dumpster,
  onReserve
}: {
  dumpster: DumpsterSize;
  onReserve: () => void;
}) {
  return <article className={cn('relative flex flex-col overflow-hidden rounded-xl border bg-card shadow-sm transition-shadow hover:shadow-md', dumpster.popular ? 'border-primary ring-1 ring-primary' : 'border-border')} data-id="element-322">
      {dumpster.popular && <Badge className="absolute left-5 top-5 z-10" data-id="element-323">Most popular</Badge>}
      <img src={dumpster.image} alt={`${dumpster.name} roll-off dumpster for rent`} className="h-48 w-full object-cover" data-id="element-324" />
      <div className="flex flex-1 flex-col p-6" data-id="element-325">
        <p className="text-sm font-medium text-muted-foreground" data-id="element-326">
          {dumpster.yards} cubic yards
        </p>
        <h3 className="mt-1 text-xl font-semibold text-card-foreground" data-id="element-327">
          {dumpster.name}
        </h3>
        <p className="mt-3 text-sm leading-5 text-muted-foreground" data-id="element-328">
          {dumpster.bestFor}
        </p>
        <div className="mt-5 grid grid-cols-2 gap-3 text-sm" data-id="element-329">
          <div className="rounded-lg border border-border p-3" data-id="element-330">
            <p className="text-xs text-muted-foreground" data-id="element-331">1–3 days</p>
            <p className="mt-1 text-lg font-semibold text-foreground" data-id="element-332">
              {formatCurrency(dumpster.shortRate)}
            </p>
          </div>
          <div className="rounded-lg border border-primary/30 bg-primary/5 p-3" data-id="element-333">
            <p className="text-xs font-medium text-primary" data-id="element-334">7 days</p>
            <p className="mt-1 text-lg font-semibold text-foreground" data-id="element-335">
              {formatCurrency(dumpster.weekRate)}
            </p>
          </div>
        </div>
        <ul className="mt-5 space-y-2 text-sm text-muted-foreground" data-id="element-336">
          <li className="flex items-center gap-2" data-id="element-337">
            <Check className="h-4 w-4 shrink-0 text-primary" data-id="element-338" />
            Up to {dumpster.weightLimit}
          </li>
          <li className="flex items-center gap-2" data-id="element-339">
            <Check className="h-4 w-4 shrink-0 text-primary" data-id="element-340" />
            {dumpster.dimensions}
          </li>
        </ul>
        <Button className="mt-6 w-full" variant={dumpster.popular ? 'default' : 'outline'} onClick={onReserve} data-id="element-341">
          Reserve this size
        </Button>
      </div>
    </article>;
}